var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/2px/outline/edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/2px/outline/edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,18.2272413 L10.9984589,22.2272413 L8,18.2272413 L8,5.22724134 C8,4.12267184 8.8954305,3.22724134 10,3.22724134 L12,3.22724134 C13.1045695,3.22724134 14,4.12267184 14,5.22724134 L14,18.2272413 Z M11,5.22724134 C10.4477153,5.22724134 10,5.67495659 10,6.22724134 L10,17.5608487 L10.9992808,18.8939079 L12,17.5603007 L12,6.22724134 C12,5.67495659 11.5522847,5.22724134 11,5.22724134 Z M10,7.22724134 L12,7.22724134 L12,9.22724134 L10,9.22724134 L10,7.22724134 Z",
    id: "icon_edit",
    fill: "#056CBA",
    fillRule: "nonzero",
    transform: "translate(11.000000, 12.727241) rotate(45.000000) translate(-11.000000, -12.727241) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.17e006ab1471221f80d9ed1057b90a2b.svg";
export { ForwardRef as ReactComponent };